(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-carousel"] && !window.DesignMode) return;
  try {
    
  $(document).ready(function() {
    $('#lightSlider').lightSlider({
        item:3,
        gallery: false,
        slideMargin: 40,
        loop:true,
        pager: false,
        slideMove:5,
        easing: 'cubic-bezier(0.25, 0, 0.25, 1)',
        speed:600,
        responsive : [
            {
                breakpoint:850,
                settings: {
                    item:2,
                    slideMove:1,
                    slideMargin:5
                  }
            },
            {
                breakpoint:500,
                settings: {
                    item:1,
                    slideMove:1
                  }
            }
        ]
    });  
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-details-copy"]) return;
  try {
    
  $(document).ready(function () {
    // Bestehender Code für die Accordions
    var $summaries = $('#product-description details > summary');

    if ($summaries.length > 0) {
      $summaries.each(function (index, element) {
        $(element).on('click', function () {
          var $thisDetails = $(this).parent();

          // Verzögerung hinzufügen, um das native Verhalten abzuwarten
          setTimeout(function () {
            if ($thisDetails.attr('open')) {
              // Schließen aller anderen geöffneten Accordions
              var $openDetails = $('#product-description details[open]').not($thisDetails);
              $openDetails.removeAttr('open');
            }
          }, 1);
        });
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-details-copy2"]) return;
  try {
    
  $(document).ready(function () {
    // Bestehender Code für die Accordions
    var $summaries = $('#product-description details > summary');

    if ($summaries.length > 0) {
      $summaries.each(function (index, element) {
        $(element).on('click', function () {
          var $thisDetails = $(this).parent();

          // Verzögerung hinzufügen, um das native Verhalten abzuwarten
          setTimeout(function () {
            if ($thisDetails.attr('open')) {
              // Schließen aller anderen geöffneten Accordions
              var $openDetails = $('#product-description details[open]').not($thisDetails);
              $openDetails.removeAttr('open');
            }
          }, 1);
        });
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-details"] && !window.DesignMode) return;
  try {
    
  $(document).ready(function () {
    // Bestehender Code für die Accordions
    var $summaries = $('#product-description details > summary');

    if ($summaries.length > 0) {
      $summaries.each(function (index, element) {
        $(element).on('click', function () {
          var $thisDetails = $(this).parent();

          // Verzögerung hinzufügen, um das native Verhalten abzuwarten
          setTimeout(function () {
            if ($thisDetails.attr('open')) {
              // Schließen aller anderen geöffneten Accordions
              var $openDetails = $('#product-description details[open]').not($thisDetails);
              $openDetails.removeAttr('open');
            }
          }, 1);
        });
      });
    }
  });

  $(document).ready(function () {
    $('#product-pics').lightSlider({
      item: 1,
      gallery: true,
      thumbItem: 9,
      slideMargin: 40,
      loop: true,
      pager: true,
      slideMove: 5,
      easing: 'cubic-bezier(0.25, 0, 0.25, 1)',
      speed: 600,

      slideMargin: 0,
      enableDrag: true,
      currentPagerPosition: 'left',
    });
  });

  /**
   * AJAX-Funktionalität für Plus/Minus-Buttons:
   * - Ohne Seitenreload soll das Produkt im Warenkorb erhöht/gesenkt werden.
   * - Danach wird der Discount neu berechnet und die UI (Mengen, aktive Klassen,
   *   Hinweistext & rabattierte Preise) aktualisiert.
   * - Während des Updates zeigen wir den Spinner an.
   */

  (function () {
    // Produkt zum Warenkorb hinzufügen (wenn noch nicht drin) oder erhöhen
    function addToCart(variantId, quantityDelta) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [
            {
              id: variantId,
              quantity: quantityDelta,
            },
          ],
        }),
      })
        .then((response) => response.json())
        .catch((error) => console.error(error));
    }

    // Menge im Warenkorb ändern
    function changeCart(variantId, quantityDelta) {
      return fetch('/cart.js')
        .then((response) => response.json())
        .then((cart) => {
          // Passendes cart item suchen
          let lineItem = cart.items.find((item) => item.variant_id === parseInt(variantId, 10));

          if (lineItem) {
            let newQty = lineItem.quantity + quantityDelta;

            if (newQty <= 0) {
              // Produkt entfernen
              return fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                  id: lineItem.key,
                  quantity: 0,
                }),
              }).then((res) => res.json());
            } else {
              // Menge aktualisieren
              return fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                  id: lineItem.key,
                  quantity: newQty,
                }),
              }).then((res) => res.json());
            }
          } else {
            // Wenn Produkt noch nicht im Warenkorb ist, direkt hinzufügen
            return addToCart(variantId, quantityDelta);
          }
        })
        .catch((error) => console.error(error));
    }

    /**
     * Zeigt den Spinner (loading-spinner) an und versteckt die cart-quantity.
     */
    function showSpinner(li) {
      let quantityElem = li.querySelector('.cart-quantity');
      let spinnerElem = li.querySelector('.loading__spinner');
      if (quantityElem && spinnerElem) {
        // Die Mengenanzeige ausblenden
        quantityElem.classList.add('hidden');
        // Den Spinner einblenden
        spinnerElem.classList.remove('hidden');
      }
    }

    /**
     * Versteckt den Spinner und zeigt die cart-quantity.
     */
    function hideSpinner(li) {
      let quantityElem = li.querySelector('.cart-quantity');
      let spinnerElem = li.querySelector('.loading__spinner');
      if (quantityElem && spinnerElem) {
        // Die Mengenanzeige einblenden
        quantityElem.classList.remove('hidden');
        // Den Spinner ausblenden
        spinnerElem.classList.add('hidden');
      }
    }

    // Aktualisiert UI anhand der aktuellen cart.js-Daten
    function updateUI() {
      return fetch('/cart.js')
        .then((response) => response.json())
        .then((cart) => {
          // 1) Neuen Discount basierend auf cart.item_count bestimmen
          let discount = 0;
          if (cart.item_count >= 3 && cart.item_count <= 5) {
            discount = 0.1;
          } else if (cart.item_count >= 6 && cart.item_count <= 8) {
            discount = 0.15;
          } else if (cart.item_count >= 9) {
            discount = 0.2;
          }

          // Basispreis lesen:
          const priceElement = document.querySelector('.price .reduced-price, .price .normal');

          if (priceElement) {
            const basePriceCents = parseInt(priceElement.getAttribute('data-base-price-cents'), 10);
            var discountedCents = Math.round(basePriceCents * (1 - discount));
            priceElement.textContent = formatMoney(discountedCents);
          }

          const cartCountBubble = document.querySelector('.cart-count-bubble');
          if (cartCountBubble) {
            cartCountBubble.textContent = cart.item_count;
          }

          const priceArg = document.querySelector('.price-arg');
          const priceArg2 = document.querySelector('.price-arg2');

          if (priceArg && discountedCents) {
            const portionen = parseInt(priceArg.getAttribute('data-portionen'), 10);
            var pricePerPortion = Math.round(discountedCents / portionen);
            priceArg.innerHTML =
              'nur ' + formatMoney(pricePerPortion) + ' pro Portion<span class="superscript">*</span>';
            priceArg2.innerHTML =
              'nur ' + formatMoney(pricePerPortion) + ' pro Portion<span class="superscript">*</span>';
          }

          // 2) cart-count-info aktualisieren
          const cartCountInfo = document.querySelector('.cart-count-info');
          if (cartCountInfo) {
            cartCountInfo.innerHTML = `Bisher in deinem Warenkorb: ${cart.item_count} Stück`;
          }

          // 3) amount-icon-Klassen updaten
          const lowDiv = document.querySelector('.low');
          const middleDiv = document.querySelector('.middle');
          const highDiv = document.querySelector('.high');
          if (lowDiv && middleDiv && highDiv) {
            lowDiv.classList.remove('active');
            middleDiv.classList.remove('active');
            highDiv.classList.remove('active');
            lowDiv.children[0].innerHTML = 'Spare 10%';
            middleDiv.children[0].innerHTML = 'Spare 15%';
            highDiv.children[0].innerHTML = 'Spare 20%';

            if (cart.item_count >= 3 && cart.item_count <= 5) {
              lowDiv.classList.add('active');
              lowDiv.children[0].innerHTML = 'Du sparst 10%';
            } else if (cart.item_count >= 6 && cart.item_count <= 8) {
              middleDiv.classList.add('active');
              middleDiv.children[0].innerHTML = 'Du sparst 15%';
            } else if (cart.item_count >= 9) {
              highDiv.classList.add('active');
              highDiv.children[0].innerHTML = 'Du sparst 20%';
            }
          }

          // 4) Text in .additional-info neu
          const additionalInfoDiv = document.querySelector('.additional-info');
          if (additionalInfoDiv) {
            let text = '';
            if (cart.item_count < 3) {
              let needed = 3 - cart.item_count;
              text = `Füge deinem Warenkorb <span class="bold">weitere ${needed} Artikel</span> hinzu, um
                      <span class="bold">10% Rabatt</span> auf deinen gesamten Einkauf zu erhalten.`;
            } else if (cart.item_count >= 3 && cart.item_count < 6) {
              let needed = 6 - cart.item_count;
              text = `Füge deinem Warenkorb <span class="bold">weitere ${needed} Artikel</span> hinzu, um
                      <span class="bold">15% Rabatt</span> auf deinen gesamten Einkauf zu erhalten.`;
            } else if (cart.item_count >= 6 && cart.item_count < 9) {
              let needed = 9 - cart.item_count;
              text = `Füge deinem Warenkorb <span class="bold">weitere ${needed} Artikel</span> hinzu, um
                      <span class="bold">20% Rabatt</span> auf deinen gesamten Einkauf zu erhalten.`;
            } else {
              text = `Super! Du hast <span class="bold">bereits 20% Rabatt</span> erreicht.
                      <span class="bold">Jeder weitere Artikel</span>, den du deinem Warenkorb hinzufügst,
                      <span class="bold">ist automatisch 20% günstiger</span>.`;
            }
            additionalInfoDiv.innerHTML = text;
          }

          // 5) Produktliste updaten: Mengen + Preise
          document.querySelectorAll('.recommended-products .product-item').forEach((li) => {
            let variantId = parseInt(li.getAttribute('data-variant-id'), 10);
            let basePriceCents = parseInt(li.getAttribute('data-base-price-cents'), 10);

            // Finde passendes Item im Cart
            let cartLine = cart.items.find((item) => item.variant_id === variantId);
            let quantity = cartLine ? cartLine.quantity : 0;

            // Menge aktualisieren
            let qtySpan = li.querySelector('.cart-quantity');
            if (qtySpan) {
              qtySpan.textContent = quantity;
            }

            // Neuen Preis berechnen
            let discountMultiplier = 1 - discount;
            let discountedCents = Math.round(basePriceCents * discountMultiplier);

            // .price-discounted aktualisieren
            let discountedSpan = li.querySelector('.price-discounted');
            if (discountedSpan) {
              discountedSpan.textContent = formatMoney(discountedCents);
            }
          });

          // 6) Berechnung Restbetrag Versand aktualisieren.
          const shippingInfoElem = document.querySelector('.shipping-info');
          const shippingThreshold = shippingInfoElem
            ? parseInt(shippingInfoElem.getAttribute('data-threshold'), 10)
            : 0;

          if (shippingThreshold !== 0) {
            const thresholdElem = document.querySelector('.threshold');
            if (thresholdElem) {
              if (cart.total_price >= shippingThreshold) {
                thresholdElem.textContent = 'Glückwunsch! Mit deinem Warenkorb profitierst du von kostenlosem Versand.';
              } else {
                const remaining = shippingThreshold - cart.total_price;
                thresholdElem.innerHTML =
                  '<img style="vertical-align: middle; width: 1.5rem; height:1.5rem" src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCI+PGNpcmNsZSBjeD0iMTAiIGN5PSIxMCIgcj0iOSIgc3Ryb2tlPSJibGFjayIgZmlsbD0id2hpdGUiIC8+PHRleHQgeD0iMTAiIHk9IjE1IiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmb250LXNpemU9IjEyIiBmaWxsPSJibGFjayI+aTwvdGV4dD48L3N2Zz4=" alt="Info Icon">' +
                  ' Füge Artikel im Wert von <span id="shipping_threshold">' +
                  formatMoney(remaining) +
                  '</span> hinzu, um kostenlosen Versand zu erhalten.';
              }
            }
          }
        })
        .catch((error) => console.error(error));
    }

    // Vereinfachte money-Formatierung in Euro (o.ä.)
    function formatMoney(cents) {
      return (cents / 100).toLocaleString('de-DE', {
        style: 'currency',
        currency: 'EUR',
      });
    }

    document.addEventListener('DOMContentLoaded', function () {
      // Alle Minus-Buttons
      document.querySelectorAll('.recommended-products .minus-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          // Spinner zeigen
          const li = btn.closest('.product-item');
          showSpinner(li);

          let variantId = this.getAttribute('data-variant-id');
          changeCart(variantId, -1)
            .then(() => updateUI())
            .then(() => hideSpinner(li))
            .catch((err) => {
              console.error(err);
              hideSpinner(li);
            });
        });
      });

      // Alle Plus-Buttons
      document.querySelectorAll('.recommended-products .plus-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          // Spinner zeigen
          const li = btn.closest('.product-item');
          showSpinner(li);

          let variantId = this.getAttribute('data-variant-id');
          changeCart(variantId, 1)
            .then(() => updateUI())
            .then(() => hideSpinner(li))
            .catch((err) => {
              console.error(err);
              hideSpinner(li);
            });
        });
      });

      // Warenkorb Button
      // Hier WEITER:
      // Hinzufügen via Add To Cart braucht noch Positivmeldung sowie Aktualisierung des cart-count-bubble Divs am Warenkorb

      document.querySelector('#add-to-cart').addEventListener('click', function (event) {
        event.preventDefault(); // nur falls du sicher gehen willst, dass kein Formular-Submit passiert
        this.disabled = true;
        this.classList.add('deactivated');
        this.textContent = '... Artikel wird hinzugefügt ...';

        // a) Variant-ID aus dem versteckten Input holen:
        const variantIdInput = document.querySelector('input[name="id"]');
        const variantId = parseInt(variantIdInput.value, 10);

        // b) Menge aus dem Mengenwähler auslesen:
        const quantityInput = document.querySelector('.quantity__input');
        const quantity = parseInt(quantityInput.value, 10);

        // c) Per AJAX hinzufügen/aktualisieren
        //    statt `1` übergeben wir jetzt die gewünschte `quantity`:
        changeCart(variantId, quantity)
          .then(() => updateUI())
          .then(() => {
            // Jetzt erst den Timeout starten
            setTimeout(() => {
              this.disabled = false;
              this.textContent = 'In den Warenkorb legen';
              this.classList.remove('deactivated');
            }, 100);
          })
          .catch((err) => {
            console.error(err);
            this.disabled = false;
            this.textContent = 'Fehler: Nochmal versuchen';
            this.classList.remove('deactivated');
          });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-related-recipe"] && !window.DesignMode) return;
  try {
    
  $(document).ready(function () {
    $('#recipeSlider').lightSlider({
      item: 3,
      gallery: false,
      slideMargin: 40,
      loop: true,
      pager: false,
      slideMove: 5,
      easing: 'cubic-bezier(0.25, 0, 0.25, 1)',
      speed: 600,
      adaptiveHeight: true,
      responsive: [
        {
          breakpoint: 850,
          settings: {
            item: 2,
            slideMove: 1,
            slideMargin: 5,
          },
        },
        {
          breakpoint: 500,
          settings: {
            item: 1,
            slideMove: 1,
          },
        },
      ],
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["receipe-carousel"] && !window.DesignMode) return;
  try {
    
  $(document).ready(function () {
    $('#recipeSlider').lightSlider({
      item: 3,
      gallery: false,
      slideMargin: 40,
      loop: true,
      pager: false,
      slideMove: 1,
      easing: 'cubic-bezier(0.25, 0, 0.25, 1)',
      speed: 600,
      responsive: [
        {
          breakpoint: 850,
          settings: {
            item: 2,
            slideMove: 1,
            slideMargin: 5,
          },
        },
        {
          breakpoint: 500,
          settings: {
            item: 1,
            slideMove: 1,
          },
        },
      ],
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews"] && !window.DesignMode) return;
  try {
    
  $(document).ready(function () {
    $('#review-slider').lightSlider({
      item: 1,
      gallery: false,
      slideMargin: 0,
      loop: true,
      pager: false,
      slideMove: 1,
      easing: 'cubic-bezier(0.25, 0, 0.25, 1)',
      speed: 600,
      slide: '.review-pair',
      responsive: [
        {
          breakpoint: 719,
          settings: {
            item: 1,
            slideMove: 1,
            slideMargin: 0,
          },
        },
      ],
    });
  });

  } catch(e) { console.error(e); }
})();
})();
